// extracted by mini-css-extract-plugin
module.exports = {"container":"MyProjects_container__JC-nC","myProjects":"MyProjects_myProjects__3YMSE","headerWrapper":"MyProjects_headerWrapper__9mWCf","header":"MyProjects_header__1YbpP"};